import axios from "axios";
import router from "@/router";
import Cookies from "js-cookie";
// import { useNotificationStore } from "@/store/NotificationStore";
//import { useErrorsStore } from "@/store/errorsStore";

// const baseURL = "https://saas.blco.pro";
const baseURL =
    (window.env && window.env.BASE_URL)
        ? window.env.BASE_URL
        : "http://192.168.2.100:9101";
        // : "http://0.0.0.0:9101";

// const baseURL = (window.env && window.env.BASE_URL)
//     ? window.env.BASE_URL
//     : (process.env.VUE_APP_BASE_URL || "http://localhost:8080/api/v1");

export var api = axios.create({
    baseURL: baseURL,
    // авторизация по токену
    headers: {
        'Authorization': `Bearer ${Cookies.get('access_token') || ''}`
    }
});

export const setAccessToken = async (token) => {
    api = axios.create({
        baseURL: baseURL,
        // авторизация по токену
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    setInterceptors(api);
}

export const removeAccessToken = () => {
    api = axios.create({
        baseURL: baseURL,
        // авторизация по токену
        headers: {
            'Authorization': ``
        }
    });

    setInterceptors(api);
}



const setInterceptors = (api) => {
    // Добавляем перехватчик ответов
    api.interceptors.response.use(
        (response) => {
            // Check if response data is just text
            if (typeof response.data === 'string' && response.data.trim().length > 0) {
                try {
                    // const notificationStore = useNotificationStore();
                    // notificationStore.addNotification({ message: response.data, type: 'success' });
                } catch (e) {
                    // Pinia might not be ready or other issue
                    console.error('Notification error:', e);
                }
            }
            return response;
        },
        (error) => {
            // Любые ошибки за пределами диапазона 2xx вызовут эту функцию
            // console.log(error)

            // const notificationStore = useNotificationStore();
            const { status, data } = error.response || {};

            if (data && data.message && !error.config?.skipErrorNotification) {
                // notificationStore.addNotification({ message: data.message, type: 'error' });
            }

            // Глобальная обработка ошибок
            switch (status) {
                case 400:
                    //useErrorsStore().addError(400, "Неверный запрос", data);
                    console.error("Ошибка 400: Неверный запрос", data);
                    break;
                case 401:
                    console.error("Ошибка 401: Неавторизован", data);
                    // Например, перенаправление на страницу логина
                    Cookies.remove('access_token');
                    removeAccessToken();
                    router.push('/login');
                    break;
                case 403:
                    console.error("Ошибка 403: Доступ запрещен", data);
                    // router.back();
                    break;
                case 404:
                    console.error("Ошибка 404: Ресурс не найден", data);
                    break;
                case 500:
                    // console.log(error)
                    console.error("Ошибка 500: Ошибка сервера", data);
                    break;
                default:
                    console.error("Неизвестная ошибка", error);
            }

            // Пробрасываем ошибку дальше, чтобы её можно было обработать локально (в catch)
            return Promise.reject(error);
        }
    );
}

setInterceptors(api);

export default { setAccessToken, api };
